





























import { remToPx } from "@/common/dom.functions";
import { computed } from "@vue/composition-api";
import Vue from "vue";
import { UsePopup } from "../root/popup/popup.state";
import FolderPathPopupVue from "./FolderPathPopup.vue";
export default Vue.extend({
  props: {
    path: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    showTreeLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // @ts-ignore
    const full_path = computed(() => props.path.split("/"));
    // @ts-ignore
    const visible_path = computed(() =>
      full_path.value.slice(full_path.value.length - 3, -1).join("/")
    );

    const should_show_tree_link = computed(() => props.showTreeLink);

    const show_full_path_popup = (ev: MouseEvent) => {
      console.log("ev::", ev);
      UsePopup.showDisplayPopup({
        type: "CustomDisplayPopup",
        cmp: FolderPathPopupVue,
        preventOnScrollClose: true,
        items: [props.path],
        event: ev,
        position: "right",
        width: remToPx(40),
      });
    };
    return {
      visible_path,
      full_path,
      should_show_tree_link,
      show_full_path_popup,
    };
  },
});
